/**
 * Egy feltöltött fájl megnyitása — az EREDETI, változatlanul (`2.6/10`).
 *
 * ── MIÉRT NEM EGYSZERŰEN EGY `<a href>` ──────────────────────────────
 *
 * A végpont védett, a token pedig `Authorization` fejlécben utazik — egy sima
 * hivatkozásra a böngésző azt NEM teszi rá, és 401-et kapnánk. Ugyanez zárja
 * ki az `<img src>`-t és az `<embed>`-et is. Ezért töltjük le a törzset, és
 * nyitjuk meg objektum-URL-ként.
 *
 * AMI EBBŐL KÖVETKEZIK, ÉS AMIT NEM RÖGTÖNZÜNK. A helyes végső megoldás egy
 * RÖVID ÉLETŰ, ALÁÍRT hivatkozás, amit a böngésző natívan meg tud nyitni — de
 * az önálló döntés (lejárat, aláírás, visszavonás), és a Tár képernyőjével
 * együtt kell meghozni. Addig ez a néhány sor helyettesíti, kimondva.
 *
 * ── AZ ABLAKOT A KOPPINTÁS PILLANATÁBAN NYITJUK ──────────────────────
 *
 * ÜRESEN, még a letöltés ELŐTT. A böngészők a felugró-blokkolást azon mérik,
 * hogy a `window.open` a felhasználói eseményből fut-e; egy `await` UTÁN a
 * hívás már „magától indult", és néma `null` lesz belőle. Fordított
 * sorrendben tehát a gomb telefonon egyszerűen nem csinálna semmit.
 *
 * Cserébe kötelező a takarítás: ha a letöltés elhasal, az üres fület
 * BEZÁRJUK, különben egy fehér lap marad ott magyarázat nélkül.
 *
 * ── ÉS FEL IS SZABADÍTJUK, AMIT LEFOGLALTUNK ─────────────────────────
 *
 * Az objektum-URL a teljes bájtsorozatot (legfeljebb 25 MB) a lap
 * élettartamára a memóriában tartja, és minden „Megnézem" hozzátesz egy
 * újabbat. Ez telefonos PWA: az iOS Safari épp a memóriaéhes lapokat dobja el
 * a háttérben, tehát pont azt a készüléket rontanánk el, amire a funkció
 * készült.
 *
 * AZONNAL NEM SZABADÍTHATÓ FEL — a most megnyílt fülnek még kell. Ezért az
 * ELŐZŐT engedjük el, amikor a következőt nyitjuk: addigra az előző fül vagy
 * betöltötte a tartalmat (a dokumentum onnantól saját hivatkozást tart rá),
 * vagy a felhasználó továbblépett róla.
 */

import { env } from '@/config/env';
import { withSession } from '@/lib/api-client';

let previousObjectUrl: string | null = null;

export async function openUploadedFile(documentId: string): Promise<void> {
  const target = window.open('', '_blank');

  try {
    // GET, tehát CSRF-fejléc nem kell — de a süti igen, azt a
    // `credentials: 'include'` viszi (#14).
    const response = await fetch(`${env.apiUrl}/documents/${documentId}/file`, withSession({}));

    if (!response.ok) {
      throw new Error(`A fájl nem nyitható meg (${response.status}).`);
    }

    const url = URL.createObjectURL(await response.blob());

    if (previousObjectUrl !== null) {
      URL.revokeObjectURL(previousObjectUrl);
    }
    previousObjectUrl = url;

    if (target) {
      target.location.href = url;
    } else {
      // A fül megnyitása mégis elbukott (beállítás, beépülő). Egy második
      // próba a legrosszabb esetben szintén nem sikerül — de a néma
      // semmittevésnél az is jobb.
      window.open(url, '_blank');
    }
  } catch (error) {
    target?.close();
    throw error;
  }
}
